window.bundleDataN = {
"Naomi-girl": {
displayName: "Naomi",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Naomi Personalized Coloring Experience",
variantId: "49613087178989",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Naomi_final_cover.png?v=1773443858",
price: "$14.99",
preorder: true
},
{
title: "Naomi Unicorn Holographic Sticker",
variantId: "49933756006637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Naomi_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Naomi Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Natalia-girl": {
displayName: "Natalia",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Natalia Personalized Coloring Experience",
variantId: "49609740222701",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Natalia_final_cover.png?v=1773443855",
price: "$14.99",
preorder: true
},
{
title: "Natalia Unicorn Holographic Sticker",
variantId: "49933756137709",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Natalia_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Natalia Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Natalie-girl": {
displayName: "Natalie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Natalie Personalized Coloring Experience",
variantId: "49279571394797",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Natalie_final_cover.png?v=1773766536",
price: "$14.99",
preorder: true
},
{
title: "Natalie Unicorn Holographic Sticker",
variantId: "49933774291181",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Natalie_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Natalie Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Nate-boy": {
displayName: "Nate",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Nate Personalized Coloring Experience",
variantId: "49653038383341",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nate_final_cover.png?v=1773501516",
price: "$14.99",
preorder: true
},
{
title: "Nate Dragon Holographic Sticker",
variantId: "49933754826989",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nate_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Nate Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Nathan-boy": {
displayName: "Nathan",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Nathan Personalized Coloring Experience",
variantId: "49406710317293",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/NATHAN_FINAL_COVER.png?v=1771894576",
price: "$14.99",
preorder: true
},
{
title: "Nathan Dragon Holographic Sticker",
variantId: "49933767442669",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nathan_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Nathan Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Nathaniel-boy": {
displayName: "Nathaniel",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Nathaniel Personalized Coloring Experience",
variantId: "49406715986157",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/NATHANIEL_FINAL_COVER.png?v=1771894576",
price: "$14.99",
preorder: true
},
{
title: "Nathaniel Dragon Holographic Sticker",
variantId: "49933767409901",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nathaniel_holographic_sticker.png?v=1780106104",
price: "$4.99",
preorder: false
},
{
title: "Nathaniel Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Nevaeh-girl": {
displayName: "Nevaeh",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Nevaeh Personalized Coloring Experience",
variantId: "49614926840045",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nevaeh_final_cover.png?v=1773443858",
price: "$14.99",
preorder: true
},
{
title: "Nevaeh Unicorn Holographic Sticker",
variantId: "49933755908333",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nevaeh_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Nevaeh Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Nicholas-boy": {
displayName: "Nicholas",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Nicholas Personalized Coloring Experience",
variantId: "49406724079853",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/NICHOLAS_FINAL_COVER.png?v=1771894576",
price: "$14.99",
preorder: true
},
{
title: "Nicholas Dragon Holographic Sticker",
variantId: "49933767377133",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nicholas_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Nicholas Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Nick-boy": {
displayName: "Nick",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Nick Personalized Coloring Experience",
variantId: "49412001693933",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/NICK_FINAL_COVER.png?v=1772032667",
price: "$14.99",
preorder: true
},
{
title: "Nick Dragon Holographic Sticker",
variantId: "49933766852845",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nick_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Nick Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Nico-boy": {
displayName: "Nico",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Nico Personalized Coloring Experience",
variantId: "49351809466605",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nico_final_cover.png?v=1772753295",
price: "$14.99",
preorder: true
},
{
title: "Nico Dragon Holographic Sticker",
variantId: "49933770555629",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nico_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Nico Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Nicolas-boy": {
displayName: "Nicolas",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Nicolas Personalized Coloring Experience",
variantId: "49400187715821",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nicolas_final_cover.png?v=1771691713",
price: "$14.99",
preorder: true
},
{
title: "Nicolas Dragon Holographic Sticker",
variantId: "49933768917229",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nicolas_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Nicolas Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Nicole-girl": {
displayName: "Nicole",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Nicole Personalized Coloring Experience",
variantId: "49612966363373",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nicole_final_cover.png?v=1773443858",
price: "$14.99",
preorder: true
},
{
title: "Nicole Unicorn Holographic Sticker",
variantId: "49933756039405",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nicole_holographic_sticker.png?v=1780099049",
price: "$4.99",
preorder: false
},
{
title: "Nicole Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Nina-girl": {
displayName: "Nina",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Nina Personalized Coloring Experience",
variantId: "49614319812845",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nina_final_cover.png?v=1773443858",
price: "$14.99",
preorder: true
},
{
title: "Nina Unicorn Holographic Sticker",
variantId: "49933755973869",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nina_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Nina Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Noa-girl": {
displayName: "Noa",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Noa Personalized Coloring Experience",
variantId: "49754396426477",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Noa_final_cover.png?v=1775322361",
price: "$14.99",
preorder: true
},
{
title: "Noa Unicorn Holographic Sticker",
variantId: "49933752959213",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Noa_holographic_sticker.png?v=1780099045",
price: "$4.99",
preorder: false
},
{
title: "Noa Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Noah-boy": {
displayName: "Noah",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Noah Personalized Coloring Experience",
variantId: "49279571493101",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Noahfinalcover.png?v=1771571270",
price: "$14.99",
preorder: true
},
{
title: "Noah Dragon Holographic Sticker",
variantId: "49933774225645",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Noah_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Noah Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Noemi-girl": {
displayName: "Noemi",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Noemi Personalized Coloring Experience",
variantId: "49274460864749",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Noemi_final_cover.png?v=1773766535",
price: "$14.99",
preorder: true
},
{
title: "Noemi Unicorn Holographic Sticker",
variantId: "49933780746477",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Noemi_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Noemi Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Nola-girl": {
displayName: "Nola",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Nola Personalized Coloring Experience",
variantId: "49616966516973",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nola_final_cover.png?v=1773443857",
price: "$14.99",
preorder: true
},
{
title: "Nola Unicorn Holographic Sticker",
variantId: "49933755842797",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nola_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Nola Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Nolan-boy": {
displayName: "Nolan",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Nolan Personalized Coloring Experience",
variantId: "49411960963309",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/NOLAN_FINAL_COVER.png?v=1772032668",
price: "$14.99",
preorder: true
},
{
title: "Nolan Dragon Holographic Sticker",
variantId: "49933767344365",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nolan_holographic_sticker.png?v=1780106109",
price: "$4.99",
preorder: false
},
{
title: "Nolan Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Nora-girl": {
displayName: "Nora",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Nora Personalized Coloring Experience",
variantId: "49611796578541",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nora_final_cover.png?v=1773443857",
price: "$14.99",
preorder: true
},
{
title: "Nora Unicorn Holographic Sticker",
variantId: "49933756104941",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nora_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Nora Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Nova-girl": {
displayName: "Nova",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Nova Personalized Coloring Experience",
variantId: "49774109720813",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nova_final_cover.png?v=1775415295",
price: "$14.99",
preorder: true
},
{
title: "Nova Unicorn Holographic Sticker",
variantId: "49933752893677",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nova_holographic_sticker.png?v=1780099045",
price: "$4.99",
preorder: false
},
{
title: "Nova Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Norah-girl": {
displayName: "Norah",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Norah Personalized Coloring Experience",
variantId: "50305438089453",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Norahfinalcover.png?v=1784426580",
price: "$14.99",
preorder: true
},
{
title: "Norah Unicorn Holographic Sticker",
variantId: "50305507426541",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Norah_holographic_sticker.png?v=1784431196",
price: "$4.99",
preorder: false
},
{
title: "Norah Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Nash-boy": {
displayName: "Nash",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Nash Personalized Coloring Experience",
variantId: "50399789482221",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nashfinalcover.png?v=1785904985",
price: "$14.99",
preorder: true
},
{
title: "Nash Dragon Holographic Sticker",
variantId: "50449516232941",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nash_holographic_sticker.png?v=1786244664",
price: "$4.99",
preorder: false
},
{
title: "Nash Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Noelle-girl": {
displayName: "Noelle",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Noelle Personalized Coloring Experience",
variantId: "50519260659949",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Noelle_final_cover.png?v=1786941539",
price: "$14.99",
preorder: true
},
{
title: "Noelle Unicorn Holographic Sticker",
variantId: "50497541538029",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Noelle_holographic_sticker.png?v=1787505458",
price: "$4.99",
preorder: false
},
{
title: "Noelle Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Nyla-girl": {
displayName: "Nyla",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Nyla Personalized Coloring Experience",
variantId: "50643930775789",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nyla_final_cover.png?v=1788490621",
price: "$14.99",
preorder: true
},
{
title: "Nyla Unicorn Holographic Sticker",
variantId: "50643946373357",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Nyla_holographic_sticker.png?v=1788490590",
price: "$4.99",
preorder: false
},
{
title: "Nyla Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} 





};